/**
 * Enum for route names used in the web application.
 */
export enum RouteName {
  Empty = '',
  Login = 'login',
  SignUp = 'sign-up',
  ForgotPassword = 'forgot-password',
  Leads = 'leads',
  Resources = 'resources',
  Scripts = 'scripts',
  Inquiries = 'inquiries',
  Health = 'health',
  BugReports = 'bug-reports',
  CompaniesAdmin = 'companies-admin',
  PlatformCustomers = 'platform/customers',
  PlatformServiceItems = 'platform/service-items',
  PlatformReviews = 'platform/reviews',
  PlatformNotifications = 'platform/notifications',
  PlatformServiceForms = 'platform/service-forms',
  PlatformPushTokens = 'platform/push-tokens',
  PlatformStaff = 'platform/staff',
  PlatformServices = 'platform/services',
  Verification = 'verification',
  Dashboard = 'dashboard',
  Analytics = 'analytics',
  Settings = 'settings',
  Explore = 'explore',
  ExploreMap = 'explore-map',
  WaitList = 'waitlist',
  ServiceList = 'service-list',
  CompleteList = 'complete-list',
  PendingList = 'pending-list',
  ItemDetails = 'card-details',
  Help = 'help',
  MyBugReports = 'my-bug-reports',
  Companies = 'companies',
  Bookings = 'bookings',
  ResendVerification = 'resend-verification',
  ResetPassword = 'reset-password',
  ResendCode = 'resend-code',

  // Settings
  Account = 'account',
  Branding = 'branding',
  Notifications = 'notifications',
  Services = 'services',
  Staff = 'staff',
  BusinessHours = 'business-hours',
  DynamicFormBuilder = 'formBuilder',
  Embed = 'embed',
  Integrations = 'integrations',
  ApiWebhooks = 'api-webhooks',
  BillingUsage = 'billing-usage',
  DangerZone = 'danger-zone',
  ServiceListSettings = 'service-list-settings',
  ServicesGroupsSettings = 'services-groups-settings',
  Track = 'track',

  Reservation = 'reservation',
  Reserve = 'reserve',
  Reviews = 'reviews',

  Calendar = 'calendar',
  UserProfile = 'user-profile',
  Profile = 'profile', // Admin profile
  CreateProfile = 'create-profile',
  ActivityFeed = 'activity-feed',
  // common path
  Edit = 'edit',
  TrackCodeValidation = 'trackCodeValidation',
  Book = 'book',
  Chat = 'chat',
  Tutorial = 'tutorial',
  About = 'about',

  // Role
  Company = 'company',
  Customer = 'customer',
  ServiceDetails = 'ServiceDetails',

  // payment
  PaymentSuccess = 'payment-success',
  Plans = 'plans',
  SubscriptionManagement = 'subscription-management',

  // reservation
  ConfirmReservation = 'confirm-reservation',
}
